import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useParams } from 'react-router-dom';

interface Props {
  suite: string;
  location: {
    address: string;
  };
}
function Header({ suite, location: { address } }: Props) {
  const { locationId } = useParams() as { locationId: string };
  const goBack = `/locations/${locationId}`;
  return (
    <Flex h="82" p={4} borderBottom="1px" borderColor="gray.200" align="center">
      <FontAwesomeIcon icon={['fal', 'location-dot']} size="3x" color="#A57EF3" />
      <Box flex={1} px={3}>
        <Heading as="h5" size="sm" mb={1}>
          {address}
        </Heading>
        <Text fontSize="sm" color="gray.500">
          Suite selected: {suite}
        </Text>
      </Box>
      <Button as={Link} to={goBack} variant="ghost">
        <FontAwesomeIcon icon={['fal', 'xmark']} size="lg" />
      </Button>
    </Flex>
  );
}

export default Header;
